import { ReactNode, useState } from 'react';

import { Icon } from '@components';

type CollapsibleSectionProps = {
  title: string;
  /** Chevron rotation class applied while the section is open. */
  openIconClass: string;
  contentClassName: string;
  children: ReactNode;
};

const CollapsibleSection = ({
  title,
  openIconClass,
  contentClassName,
  children
}: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="box-border w-full border-t border-cofeeGreyBlue4">
      <button
        type="button"
        className="flex w-full items-center justify-between px-6 py-4 text-left hover:bg-cofeeGreyBlue1"
        onClick={() => setIsOpen((v) => !v)}
      >
        <span className="text-md font-medium text-cofeePrimary7">{title}</span>
        <Icon
          name="right"
          size="16"
          className={`!size-4 transition-transform duration-200 ${
            isOpen ? openIconClass : 'rotate-0'
          }`}
        />
      </button>
      {isOpen && <div className={contentClassName}>{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
